// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__I+VBC","active":"Radio_active__cGOam","primary":"Radio_primary__t5K1k","secondary":"Radio_secondary__EAV6S"};